import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import LongShortTable from "./LongShortTable";
import LongShortChart from "../Charts/LongShortChart";
import LongBalanceChart from "../Charts/LongBalanceChart";
import ShortBalanceChart from "../Charts/ShortBalanceChart";

const LongShortBalance = ({ data }) => {
  // <Card className="card-csc"></Card>
  return (
    <div className="longshort-ctn">
      <div className="card-csc">
        <Title six>Long Balance</Title>
        <LongBalanceChart data={data.Long_chart} />
      </div>

      <div className="card-csc">
        <Title six>Short Balance</Title>
        <ShortBalanceChart data={data.short_chart} />
      </div>
    </div>
  );
};

export default LongShortBalance;
